import {
  getFormValue,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';

export function homeAddressNotSameAsLegalChange(
  isHomeAddressNotSameAsLegalQuestionKey: FieldsEnum,
  homeAddressZipCodeQuestionKey: FieldsEnum,
  homeAddressCityQuestionKey: FieldsEnum
) {
  const isHomeAddressNotSameAsLegal = getFormValue(
    isHomeAddressNotSameAsLegalQuestionKey
  );

  setQuestionVisibility({
    key: homeAddressZipCodeQuestionKey,
    visible: isHomeAddressNotSameAsLegal,
    formName: FormsEnum.CalculationForm,
  });

  setQuestionVisibility({
    key: homeAddressCityQuestionKey,
    visible: isHomeAddressNotSameAsLegal,
    formName: FormsEnum.CalculationForm,
  });
}
